import { render, staticRenderFns } from "./detail1.vue?vue&type=template&id=e92341a2&scoped=true"
import script from "./detail1.vue?vue&type=script&lang=js"
export * from "./detail1.vue?vue&type=script&lang=js"
import style0 from "./detail1.vue?vue&type=style&index=0&id=e92341a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92341a2",
  null
  
)

export default component.exports